import axiosInstance from "../Shared/Utils/axiosInstance";
import UserRoles from "../Shared/Constant/UserRoles";
import GetAreaId from "../Shared/Utils/getAreaId";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";
import { errorShow } from "./IECModuleService";
const districtName = sessionStorage.getItem("districtName");
const talukaName = sessionStorage.getItem("talukaName");
const role = sessionStorage.getItem("userRole");
const districtId = sessionStorage.getItem("districtId");
const talukaId = sessionStorage.getItem("talukaId");
const phcId = sessionStorage.getItem("phcId");

export const getNotificationsFromServer = async () => {
  try {
    return await axiosInstance.get(`/reminder/ViewNotifications`);
  } catch (error) {
    throw error;
  }
};
function getRoleProfile(chosenRole) {
  if(chosenRole === "ANM + Asha"){
    chosenRole = "ANM,Asha"
  }else if (chosenRole === "ANM + Asha + AF"){
     chosenRole = "ANM,Asha,AF"
  }
  return ["Asha", "ANM", "ASHA", "Af", "af", "AF", "Anm", "asha", "anm", "ANM,Asha","ANM,Asha,AF"].includes(chosenRole) ? chosenRole : "";
}
function buildRequestBody(
  decrypted,
  areaId,
  roleProfile,
  month,
  year,
  selectedLanguageId
) {
  if (role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) {
    return {
      stateId: decrypted.stateId,
      areaId: areaId,
      month: month,
      year: year,
      roleName: roleProfile,
      languageId: selectedLanguageId,
    };
  } else {
    return {
      stateId: decrypted.stateId,
      areaId: areaId,
      districtIds: decrypted.districtId ? [decrypted.districtId] : [],
      talukaIds: decrypted.talukaId ? [decrypted.talukaId] : [],
      phcIds: decrypted.phcId ? [decrypted.phcId] : null,
      month: month,
      year: year,
      roleName: roleProfile,
      languageId: selectedLanguageId,
    };
  }
}
async function sendRequest(requestBody, decrypted,tabIndex, page, pageSize) {
  let response;
  const isActive = Number(tabIndex) === 0 ?  "Active" :"Inactive" ;
  if (role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) {
    requestBody.districtIds = decrypted.districtId
      ? [decrypted.districtId]
      : [];
    requestBody.talukaIds = decrypted.talukaId ? [decrypted.talukaId] : [];
    requestBody.phcIds = decrypted.phcId ? [decrypted.phcId] : [];
    requestBody.stateIds = decrypted.stateId ? [decrypted.stateId] : 0;
    requestBody.status = isActive;
    response = await axiosInstance.post(
      `/api/V2/getTotalAshaANMByStatus?page=${page}&pageSize=${pageSize}`,
      requestBody
    );
  } else {
    requestBody.districtIds = decrypted.districtId
      ? [decrypted.districtId]
      : [];
    requestBody.talukaIds = decrypted.talukaId ? [decrypted.talukaId] : [];
    requestBody.phcIds = decrypted.phcId ? [decrypted.phcId] : [];
    requestBody.stateIds = decrypted.stateId ? [decrypted.stateId] : 0;
    requestBody.status = isActive;
    response = await axiosInstance.post(
      `/api/V2/getTotalAshaANMByStatus?page=${page}&pageSize=${pageSize}`,
      requestBody
    );
  }
  return response;
}
function handleError(error) {
  if (error.response && error.response.status === 404) {
    return [];
  }
  throw new Error(errorShow);
}
export async function getTotalAshaAnmData(
  areaType,
  chosenRole,
  month,
  year,
  selectedLanguageId,
  tabIndex,
  page,
  pageSize
) {
  let areaId = GetAreaId(areaType);
  const tokenData = sessionStorage.getItem("entireToken");
  const decrypted = TokenDecrypt(tokenData);
  const roleProfile = getRoleProfile(chosenRole);
  try {
    const requestBody = buildRequestBody(
      decrypted,
      areaId,
      roleProfile,
      month,
      year,
      selectedLanguageId
    );
    const response = await sendRequest(requestBody, decrypted, tabIndex,page, pageSize);
    const decryptData = TokenDecrypt(response.data.data);
    return { data:decryptData.data, totalCount: decryptData?.totalCount, page: decryptData?.page
        ,pageSize: decryptData?.pageSize};
  } catch (error) {
    handleError(error);
  }
}
export async function getAshaANMByStatus(areaId) {
  try {
    let response;
    if (role === UserRoles.ADMIN || role === UserRoles.SUPERADMIN) {
      response = await axiosInstance.get(
        `/api/getAshaANMByStatus?areaTypeId=${areaId}`
      );
    } else {
      response = await axiosInstance.get(
        `/api/getAshaANMByStatus?areaTypeId=${areaId}&districtName=${districtName}&talukaName=${talukaName}`
      );
    }
    
    return TokenDecrypt(response.data);
  } catch (error) {
    throw new Error(errorShow);
  }
}
export const fetchOnIncentive = async (
  area,
  selectedLanguageId,
  district,
  taluka,
  roles,
  selectedMonth,
  selectedYear
) => {
  const requestData = {
    areaId: area,
    district: district,
    taluka: taluka,
    month: selectedMonth,
    year: selectedYear,
  };
  if (roles === UserRoles.PHCHEAD) {
    requestData.district = districtId;
    requestData.taluka = talukaId;
  } else {
    requestData.district = district;
    requestData.taluka = taluka;
  }
  const response = await axiosInstance.post(
    `/api/ashasBasedOnIncentives/${selectedLanguageId}`,
    requestData
  );
  return TokenDecrypt(response.data);
};
export const fetchTopAshaTableDetails = async (
  areaTypeId,
  selectedLanguageId,
  district,
  taluka,
  roles,
  month,
  year
) => {
  const reqObj = {
    areaId: areaTypeId,
    languageId: selectedLanguageId,
    districtIds: district,
    talukaIds: taluka,
    month: month,
    year: year,
    roleName: "ASHA",
  };
  if (role === UserRoles.PHCHEAD) {
    reqObj.districtIds = [districtId];
    reqObj.talukaIds = [talukaId];
  } else {
    reqObj.districtIds = district; // For other roles, pass district name
    reqObj.talukaIds = taluka;
  }
  try {
    const response = await axiosInstance.post(
      `/api/getTotalAshaANMByStatus`,
      reqObj
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw new Error(errorShow);
  }
};
export const AshaDeployedByRegion = async (chosenMonth, chosenYr) => {
  const reqObj = {
    state: [1],
    month: chosenMonth,
    year: chosenYr + "",
  };
  if (
    role === UserRoles.PHCHEAD ||
    role === UserRoles.BLOCKHEAD ||
    role === UserRoles.DISTRICTHEAD
  ) {
    reqObj.districtIds = [districtId];
    reqObj.talukaIds = [talukaId];
    reqObj.phc = [phcId];
  }
  const response = await axiosInstance.post(
    `/api/getAshaCountDeployedByRegion`,
    reqObj
  );
  return TokenDecrypt(response.data.data);
};

export const fetchIncentiveActivity = async (
  ashaId,
  selectedLanguageId,
  month,
  year
) => {
  try {
    const response = await axiosInstance.get(
      `/api/getAshaIncentiveActivity/${selectedLanguageId}?ashaId=${ashaId}&month=${month}&year=${year}`
    );
    const decrypt = TokenDecrypt(response.data.data);
    return decrypt;
  } catch (error) {
    console.error("Error fetching incentive details:", error);
    return [];
  }
};
export const fetchTotalAsha = async (
  areaTypeId,
  selectedLanguageId,
  status
) => {
  const tokenData = sessionStorage.getItem("entireToken");
  const decrypted = TokenDecrypt(tokenData);
  let reqObj = {
    areaId: areaTypeId,
    roleName: 'Asha',
    status: status,
    stateId: decrypted.stateId
    ? decrypted.stateId
    : 0,
    districtIds: decrypted.districtId ? [decrypted.districtId] : [],
    talukaIds: decrypted.talukaId ? [decrypted.talukaId] : []
  };
  if (role.includes(UserRoles.PHCHEAD)) {
    reqObj.districtIds = decrypted.districtId ? [decrypted.districtId] : []; 
    reqObj.talukaIds = decrypted.talukaId ? [decrypted.talukaId] : [];
    reqObj.phcIds = [decrypted.phcId
      ? decrypted.phcId
      : 0,];
  }
  try {
    const response = await axiosInstance.post(
      `/api/getAllAshas/${selectedLanguageId}`,
      reqObj
    );
    if (!response || !response.data || !response.data.data) {
      return [];
    }
    const decrypt = TokenDecrypt(response.data.data);
    return decrypt;
  } catch (error) {
    return [];
  }
};
export const fetchTotalAsha_V2 = async (
  areaTypeId,
  selectedLanguageId,
  status,page,pageSize,filters
) => {
  const tokenData = sessionStorage.getItem("entireToken");
  const decrypted = TokenDecrypt(tokenData);
  let reqObj = {
    areaId: areaTypeId,
    roleName: 'Asha',
    status: status,
    stateId: decrypted.stateId
    ? decrypted.stateId
    : 0,
    districtIds: decrypted.districtId ? [decrypted.districtId] : [],
    talukaIds: decrypted.talukaId ? [decrypted.talukaId] : []
  };
  if (role.includes(UserRoles.PHCHEAD)) {
    reqObj.districtIds = decrypted.districtId ? [decrypted.districtId] : []; 
    reqObj.talukaIds = decrypted.talukaId ? [decrypted.talukaId] : [];
    reqObj.phcIds = [decrypted.phcId
      ? decrypted.phcId
      : 0,];
  }
  try {
    let apiUrl = `/api/V2/getAllAshas/${selectedLanguageId}?page=${page}&pageSize=${pageSize}`;
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (value instanceof Date) {
          const formattedDate = value.toISOString().split("T")[0]; 
          apiUrl += `&${key}=${encodeURIComponent(formattedDate)}`;
        } else {
          apiUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      }
    });
    const response = await axiosInstance.post(
      apiUrl,
      reqObj
    );
    if (!response || !response.data || !response.data.data) {
      return [];
    }
    const decryptData = TokenDecrypt(response.data.data);
    return { data:decryptData.data, totalCount: decryptData?.totalCount, page: decryptData?.page
        ,pageSize: decryptData?.pageSize};
  } catch (error) {
    return [];
  }
};
export const fetchTotalDashboardCount = async (
  areaTypeId,
  selectedLanguageId,
  phc
) => {
  const tokenData = sessionStorage.getItem("entireToken");
  const incentive_role = sessionStorage.getItem("incentive_role");    
  const decrypted = TokenDecrypt(tokenData);
  let reqObj = {
    areaId: areaTypeId,
    incentiveRole:incentive_role,
    districtIds : decrypted.districtId
    ? [decrypted.districtId]
    : [],
    talukaIds :   decrypted.talukaId ? [decrypted.talukaId] : [],
    stateId :  decrypted.stateId
    ? decrypted.stateId
    : 0,
    roleName: 'Asha',
  };
  if (role.includes(UserRoles.PHCHEAD)) {
    reqObj.phcId = parseInt(phc)
  }
  try {
    const response = await axiosInstance.post(
      `/api/getDashData/${selectedLanguageId}`,
      reqObj
    );
    if (!response || !response.data || !response.data.data) {
      console.log("No data found in the response");
      return [];
    }
    const decrypt = TokenDecrypt(response.data.data);
    return decrypt;
  } catch (error) {
    console.log("Error fetching details:", error);
    return [];
  }
};


